import { AuthState } from '@okta/okta-auth-js';

import { CommissionRateMassUpdates } from '../../services/backend/CommissionRateMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommissionRateMassUpdates: () => CommissionRateMassUpdates<AuthState> = () => {
  return useBaseApiClient(CommissionRateMassUpdates);
};
